import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle";

import { Link } from "react-router-dom";
import ApmBoardIndex from "../../components/appFrontend/ApmBoard";


const APMBoarView = (props) => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Gezamelijk doel" subtitle="F-Fort" md="12" className="ml-sm-auto mr-sm-auto" />
      <Link to={{pathname: `/mijn-bureau`}}>Mijn bureau</Link>

    </Row>
    <ApmBoardIndex data={props.location.state}/>
    
  </Container>
);

export default APMBoarView;
